import { AsyncState, createAsyncStateReducer } from "react-async-stateful";

import * as LeaderboardsActions from "./Leaderboards.action";

import * as ReduxUtils from "../../lib/util/ReduxUtils";
import { LeaderboardData } from "../../lib/types/LeaderboardTypes";

export interface LeaderboardReducerState {
	leaderboards: AsyncState<{
		[groupName: string]: {
			active: LeaderboardData[];
			complete: LeaderboardData[];
		};
	}>;
}

const initialState: LeaderboardReducerState = {
	leaderboards: AsyncState.create({ __group: { active: [], complete: [] } }),
};

export default ReduxUtils.composeReducer(initialState, [
	createAsyncStateReducer<LeaderboardReducerState>({
		leaderboards: LeaderboardsActions.getGroupLeaderboards.type,
	}),
	ReduxUtils.createReducerMap({
		[LeaderboardsActions.updateLeaderboardSettings.type]: (state, action) => {
			const { fleetId, groupId, leaderboardSettings } = action.payload;
			const currentLeaderboards = state.leaderboards.value || {};
			const groupKey = groupId ? `${fleetId}/${groupId}` : fleetId;
			const groupLeaderboards = currentLeaderboards[groupKey];
			const allLeaderboardsLength =
				groupLeaderboards.active.length + groupLeaderboards.complete.length;

			if (groupLeaderboards) {
				const index = groupLeaderboards.active.findIndex(
					(lb) => lb.id === leaderboardSettings.id,
				);

				if (index !== -1) {
					state.leaderboards.value![groupKey].active[index] = {
						...leaderboardSettings,
						customSettings: leaderboardSettings,
					};
				} else {
					state.leaderboards.value![groupKey]?.active.push({
						...leaderboardSettings,
						index: allLeaderboardsLength + 1,
						unscored: true,
						customSettings: leaderboardSettings,
					});
				}
			} else {
				state.leaderboards.value![groupKey] = {
					active: [
						{
							...leaderboardSettings,
							customSettings: leaderboardSettings,
						},
					],
					complete: [],
				};
			}

			return state;
		},
	}),
]);
